export const SaintDisclaimer = () => (
  <section className="py-10 bg-muted/50">
    <div className="container-px mx-auto max-w-3xl px-4">
      <p className="text-xs text-muted-foreground leading-relaxed">
        The SAINT® Neuromodulation System is FDA-cleared for major depressive
        disorder in adults who have not achieved satisfactory improvement from
        prior antidepressant medication in the current episode. Common side
        effects include headache and scalp discomfort at the treatment site;
        rare risks include seizure and worsening mood. Discuss risks with your
        provider. Results vary. Learn more at{" "}
        <a
          href="https://www.magnusmedical.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-accent underline underline-offset-2"
        >
          magnusmedical.com
        </a>
        .
      </p>
    </div>
  </section>
);
